import { createRoot } from 'react-dom/client';

import { AudioPlayer } from './AudioPlayer';

type MountAudioPlayerParams = {
  src: string;
  name?: string;
};

type MountedAudioPlayer = {
  element: HTMLElement;
  destroy: () => void;
};

export function mountAudioPlayer({
  src,
  name,
}: MountAudioPlayerParams): MountedAudioPlayer {
  const element = document.createElement('div');
  element.addEventListener('click', event => event.stopPropagation());

  const root = createRoot(element);
  root.render(<AudioPlayer src={src} name={name} />);

  return {
    element,
    destroy: () => root.unmount(),
  };
}
